export const CS_DATE_ROUTE_NAMES = {
  ROOT: 'cs-date-root',
  LAYOUT: 'cs-date-layout',
  CONFIGURE: 'cs-date-configure',
  RESERVATION_LIST: 'cs-reservation-list',
  RESERVATION_DETAIL: 'cs-reservation-detail',
  RESERVATION_EDIT: 'cs-reservation-edit',
  RESERVATION_CREATE: 'cs-reservation-create',
}
